module.exports = __webpack_public_path__ + "img/logo.792f6229.png";